import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const StorageKeys = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  userRole: "userRole",
  userMail: "userMail",
};

const setTokens = ({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}) => {
  localStorage.setItem(StorageKeys.accessToken, accessToken);
  localStorage.setItem(StorageKeys.refreshToken, refreshToken);
};

const setUserRole = (userRole: string) => {
  localStorage.setItem(StorageKeys.userRole, userRole);
};

const setUserMail = (userMail: string) => {
  localStorage.setItem(StorageKeys.userMail, userMail);
};

const removeTokens = () => {
  localStorage.removeItem(StorageKeys.accessToken);
  localStorage.removeItem(StorageKeys.refreshToken);
};

const removeUserRole = () => {
  localStorage.removeItem(StorageKeys.userRole);
};

const removeUserMail = () => {
  localStorage.removeItem(StorageKeys.userMail);
};

interface AuthState {
  accessToken: string;
  refreshToken: string;
  userRole?: string;
  userDetails?: UserProfile;
  userMail?: string;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem(StorageKeys.accessToken) || "",
  refreshToken: localStorage.getItem(StorageKeys.refreshToken) || "",
  userRole: localStorage.getItem(StorageKeys.userRole) || "",
  userDetails: undefined,
  userMail: localStorage.getItem(StorageKeys.userMail) || "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<AuthState>) => {
      setTokens(action.payload);
      setUserRole(action.payload.userRole ?? "");
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.userRole = action.payload.userRole;
      if (typeof action.payload.userMail === "string") {
        setUserMail(action.payload.userMail);
        state.userMail = action.payload.userMail;
      }
    },
    logout: (state) => {
      removeTokens();
      removeUserRole();
      state.accessToken = "";
      state.refreshToken = "";
      state.userRole = "";
      removeUserMail();
      state.userMail = "";
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload.userDetails;
    },
  },
});

export const { login, logout, setUserDetails } = authSlice.actions;
export default authSlice.reducer;
